import { memo, MouseEvent, useState } from 'react'
import { FieldPath, FieldValues, UseControllerProps } from 'react-hook-form'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment, TextFieldProps } from '@mui/material'
import Input from './Input'

const Password = <
  T extends FieldValues = FieldValues,
  S extends FieldPath<T> = FieldPath<T>,
>(
  props: Omit<TextFieldProps, 'type' | 'variant'> & UseControllerProps<T, S>
) => {
  const [showPassword, setShowPassword] = useState(false)
  return (
    <Input
      {...props}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={
                  showPassword ? 'hide the password' : 'display the password'
                }
                sx={{ opacity: 0.5 }}
                tabIndex={-1}
                onClick={() => setShowPassword((prev) => !prev)}
                onMouseDown={(event: MouseEvent<HTMLButtonElement>) => {
                  event.preventDefault()
                }}
                onMouseUp={(event: MouseEvent<HTMLButtonElement>) => {
                  event.preventDefault()
                }}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      type={showPassword ? 'text' : 'password'}
    />
  )
}

export default memo(Password) as typeof Password
